import type { Editor } from 'slate';
import type { EditorPlugin } from '../../types/aha-editor';

export const normalizeTableOfContentsEnabled = (editor: Editor) => {
  if (!editor.metadata) {
    editor.metadata = {
      annotations: {},
      tableOfContentsEnabled: false,
    };
  }

  if (!Object.hasOwn(editor.metadata, 'tableOfContentsEnabled')) {
    editor.metadata.tableOfContentsEnabled = false;
  }

  return false;
};

const TableOfContentsEnabledNormalizationPlugin: EditorPlugin = {
  name: 'Table of contents enabled normalization plugin',
  metadataNormalizations: [
    {
      run: normalizeTableOfContentsEnabled,
    },
  ],
};

export default TableOfContentsEnabledNormalizationPlugin;
